
import ColorPicker from './ColorPicker';

function DisplayItemsElement() {

    return (
        <>
            <div className="display-items-elements-box">

                <div className="brand-name-box">
                    <div className="element color click-color">
                        <span className="color-box">
                            <ColorPicker />
                        </span>
                    </div>
                    <div className="element gradient-color click-gradientcolor">
                        <span className="gradient-color-box">
                            <img src="../assets/images/icon-gradient-color.webp" alt="" />
                        </span>

                    </div>
                    <div className="element delete">

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3h4.25a.75.75 0 1 1 0 1.5H19V18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6.5H3.75a.75.75 0 0 1 0-1.5H8zM6.5 6.5V18c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6.5h-11zm3-1.5h5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm-.25 4h1.5v8h-1.5V9zm4 0h1.5v8h-1.5V9z"></path></svg>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DisplayItemsElement